import {http} from '@/api/http.js'

var product = {
  dataSource: [],
  initProductNames: function(){
     let that = this;
     http.$get('/product/getProductList',{}
         ).then(function(res){
         if(res.code == 200){
           that.dataSource = res.data;
         }else{
           console.error(res.msg)
         }
     }).catch(function (error) {
        if(error){
          console.error(error);
        }
     });
  },
  getProductNameByProductNo: function(productNo){
    if(!productNo){
      return '';
    }
    let target = this.dataSource.find(p => productNo == p.productNo);
    if(!target){//如果没有找到,直接返回
      return productNo;
    }
    return target.productName;
  },
  getProductNoByProductName: function(productName){
    if(!productName){
      return '';
    }
    let target = this.dataSource.find(p => productName.toString().trim() === p.productName);
    if(!target){//如果没有找到,直接返回
      return productName;
    }
    return target.productNo;
  }
}

export { product }



// WEBPACK FOOTER //
// ./src/components/sonjiandan/productNameCache.js